export function getRoleDisplayName(role: string): string {
  if (role === 'anonymous') {
    return 'public';
  }
  return role;
}
